import {
  FETCH_COMPANY_DETAILS,
  FETCH_COMPANY_DETAILS_SUCCESS,
  FETCH_COMPANY_DETAILS_FAIL,
  UPDATE_COMPANY_DETAILS,
  UPDATE_COMPANY_DETAILS_SUCCESS,
  UPDATE_COMPANY_DETAILS_FAIL,
  CREATE_COMPANY_DETAILS,
  CREATE_COMPANY_DETAILS_SUCCESS,
  CREATE_COMPANY_DETAILS_FAIL,
} from "./actionTypes"

// Fetch Company Details
export const fetchCompanyDetails = () => ({
  type: FETCH_COMPANY_DETAILS,
})

export const fetchCompanyDetailsSuccess = (companyDetails) => ({
  type: FETCH_COMPANY_DETAILS_SUCCESS,
  payload: companyDetails,
})

export const fetchCompanyDetailsFail = (error) => ({
  type: FETCH_COMPANY_DETAILS_FAIL,
  payload: error,
})

// Update Company Details
export const updateCompanyDetails = (data) => ({
  type: UPDATE_COMPANY_DETAILS,
  payload: data,
})

export const updateCompanyDetailsSuccess = (companyDetails) => ({
  type: UPDATE_COMPANY_DETAILS_SUCCESS,
  payload: companyDetails,
})

export const updateCompanyDetailsFail = (error) => ({
  type: UPDATE_COMPANY_DETAILS_FAIL,
  payload: error,
})

// Create Company Details
export const createCompanyDetails = (data) => ({
  type: CREATE_COMPANY_DETAILS,
  payload: data,
})

export const createCompanyDetailsSuccess = (companyDetails) => ({
  type: CREATE_COMPANY_DETAILS_SUCCESS,
  payload: companyDetails,
})

export const createCompanyDetailsFail = (error) => ({
  type: CREATE_COMPANY_DETAILS_FAIL,
  payload: error,
})
